import React, { useMemo } from 'react';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';
import { importProductColumns } from '../../../features/purchases/importation/columns/importProductColumns';

interface ImportTableFooterProps {
  data: any[];
  actions?: any;
}

const ImportTableFooter: React.FC<ImportTableFooterProps> = ({ data, actions }) => {
  const { form } = useBasePurchase();

  const sum = (field: string) =>
    data.reduce((acc, item) => acc + Number(item[field] || 0), 0);

  const columns = useMemo(() => importProductColumns, []);
  
  const moneyFields = [
    'amount',
    'freight',
    'insurance',
    'fauca',
    'others',
    'totalCost',
    'initialCost',
    'unitCostWithExtras',
  ];
  const percentageFields = ['percentage'];
  const centeredFields = ['quantity', 'rowIndex', 'id'];

  const totals: Record<string, string | number> = {
    quantity: sum('quantity').toFixed(2),
    amount: `$${sum('amount').toFixed(2)}`,
    percentage: `${sum('percentage').toFixed(2)}%`,
    freight: `$${sum('freight').toFixed(2)}`,
    insurance: `$${sum('insurance').toFixed(2)}`,
    fauca: `$${sum('fauca').toFixed(2)}`,
    others: `$${sum('others').toFixed(2)}`,
    totalCost: `$${sum('totalCost').toFixed(2)}`,
    initialCost: `$${sum('initialCost').toFixed(2)}`,
    unitCostWithExtras: `$${sum('unitCostWithExtras').toFixed(2)}`,
  };

  const exportIva = form.exportIva || 0;
  const totalCompra =
    (form.netAmount || 0) +
    (form.freight || 0) +
    (form.insurance || 0) +
    exportIva +
    (form.fauca || 0) +
    (form.otherCosts || 0);

  return (
    <>
      {/* 🧾 Footer contable */}
      <tfoot>
        <tr>
          <td colSpan={columns.length + (actions ? 1 : 0)} className="px-6 pt-6">
            <div className="flex justify-end">
              <div className="w-full max-w-md space-y-4 text-sm uppercase">
                <p className="text-gray-700 dark:text-gray-300 flex justify-between font-medium">
                  <span>IVA DE IMPORTACIÓN</span>
                  <span>${exportIva.toFixed(2)}</span>
                </p>

                <p className="text-gray-900 flex justify-between border-t border-stroke pt-4 font-semibold dark:border-strokedark dark:text-white">
                  <span>TOTAL COMPRA</span>
                  <span>${totalCompra.toFixed(2)}</span>
                </p>
              </div>
            </div>
          </td>
        </tr>
      </tfoot>

      {/* 📦 Footer resumen columnas */}
      <tfoot>
        <tr className="text-gray-700 dark:text-gray-300 text-sm font-semibold uppercase">
          {columns.map((col, index) => {
            const key = typeof col.accessor === 'string' ? col.accessor : col.id;
            const value = key && totals.hasOwnProperty(key) ? totals[key] : '';

            const alignClass = moneyFields.includes(key)
              ? 'text-left'
              : percentageFields.includes(key)
              ? 'text-left'
              : centeredFields.includes(key)
              ? 'text-left'
              : 'text-left';

            const colKey = typeof col.accessor === 'string' ? col.accessor : col.id || `col-${index}`;

            return (
              <td key={colKey} className={`whitespace-nowrap px-4 py-2 ${alignClass}`}>
                {value}
              </td>
            );
          })}
          {actions && <td />} {/* Columna extra para acciones */}
        </tr>
      </tfoot>
    </>
  );
};

export default ImportTableFooter;
